import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { closeModal } from "../../features/modalSLice";
import SelectField from "../../components/form/SelectField";
import {
  getTaskStatuses,
  unsetTaskStatuses,
} from "../../features/taskStatusesSlice";
import { getUsers, unsetUsers } from "../../features/usersSlice";
import { unsetSelectedMileTask } from "../../features/milestonesSlice";
import InputField from "../../components/form/InputField";
import Loading from "../../components/loading/Loading";
import loadStatus from "../../util/loadStatus";
import NetworkError from "../error/NetworkError";
import { useLocation } from "react-router-dom";

const ProjectTaskDetails = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const task = useSelector((state) => state.milestones.selectedTask);
  const { loading, data: taskStatuses } = useSelector(
    (state) => state.taskStatuses
  );
  let users = useSelector((state) => state.users.data);
  users = users.map((item) => {
    return { id: item.id, name: `${item.first_name} ${item.last_name}` };
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {};

  const handleModalClose = () => {
    dispatch(unsetTaskStatuses());
    dispatch(unsetUsers());
    dispatch(unsetSelectedMileTask());
    dispatch(closeModal());
  };

  useEffect(() => {
    dispatch(getTaskStatuses());
    dispatch(getUsers());
  }, []);

  if (loading === loadStatus.loading) {
    return <Loading />;
  }

  if (loading === loadStatus.error) {
    return <NetworkError to={location.pathname} />;
  }

  return (
    <div className="p-6">
      <div className="">
        <h2>Task Details</h2>
        <h2>{task.name}</h2>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="flex flex-col w-full">
          <SelectField
            register={register}
            data={taskStatuses}
            name="status"
            errors={errors.status}
            label="Status"
          />
          {/* <SelectField
            register={register}
            data={users}
            name="assigned_to"
            errors={errors.assigned_to}
            label="Assigned To"
          /> */}
        </div>
        <div className="sm:flex justify-center items-center gap-6">
          <InputField
            register={register}
            name="start_date"
            label="Start Date"
            errors={errors.start_date}
            type="date"
          />
          <InputField
            register={register}
            name="end_date"
            label="End Date"
            errors={errors.end_date}
            type="date"
          />
        </div>

        <div className="flex justify-between items-center px-2 pt-8">
          <button
            onClick={handleModalClose}
            className="cancel-rss-btn"
            type="button"
          >
            Cancel
          </button>
          <button className="add-rss-btn" type="submit">
            Submit
          </button>
        </div>
      </form>
    </div>
  );
};

export default ProjectTaskDetails;
